import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { Container } from "./Container";
import { HeaderPhoneIcon } from "./icons/HeaderPhoneIcon";

export const Header = () => {
	const { phoneNumber, horizontalMobileLogo } = useCompanyInfo();
	const { url } = horizontalMobileLogo;

	return (
		<header className="tw:relative tw:bg-white">
			<Container className="tw:flex tw:h-full tw:flex-col">
				<div className="tw:flex tw:items-center tw:justify-between">
					<div className="bg-black tw:flex tw:h-12 tw:w-full tw:items-center tw:rounded-sm tw:outline-hidden tw:focus-within:ring-inset tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:md:h-[72px]">
						<img
							className="tw:max-h-9 tw:max-w-full tw:align-middle tw:italic tw:md:max-h-12"
							src={url}
							alt="Best Relocation"
						/>
					</div>
					{phoneNumber && (
						<a
							// Invoca phone number replacement replaces this number anyways, but adding phone number in anyways to avoid dev confusion
							href={`tel:${phoneNumber}`}
							className="tw:relative tw:flex tw:shrink-0 tw:items-center tw:rounded-lg tw:outline-hidden tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50"
						>
							<HeaderPhoneIcon className="tw:isolate tw:mr-[-18px] tw:box-content tw:rounded-full tw:border-4 tw:border-white tw:text-[1.75rem] tw:text-[#22293A] tw:md:mr-[-26px] tw:md:text-[3rem]" />
							<div className="tw:w-[132px] tw:justify-center tw:rounded-lg tw:border tw:border-[#22293A] tw:text-center tw:md:w-[194px] tw:md:border-2">
								<div className="tw:-mt-px tw:overflow-hidden tw:rounded-t-lg tw:bg-[#22293A] tw:py-3px tw:pl-5 tw:text-left tw:text-[8px] tw:leading-[100%] tw:font-bold tw:tracking-[0.32px] tw:text-white tw:uppercase tw:md:-mt-0.5 tw:md:py-1 tw:md:pl-[30px] tw:md:text-[11px] tw:md:tracking-[0.715px]">
									Instant Moving Quote
								</div>
								<div
									data-cy="header-phone-number"
									className="tw:hide-in-percy tw:max-w-[124px] tw:pt-0.5 tw:pb-3px tw:pl-5 tw:text-xs tw:leading-[100%] tw:font-bold tw:text-[#22293A] tw:md:max-w-[178px] tw:md:pt-5px tw:md:pb-1.5 tw:md:pl-[30px] tw:md:text-base tw:md:leading-[100%]"
								>
									{phoneNumber}
								</div>
							</div>
						</a>
					)}
				</div>
			</Container>
		</header>
	);
};
